'use client';

/* eslint-disable react/display-name */
import React from 'react';
import { useEffect } from 'react';
import Page from 'components/Page';
import StyleManager from 'utils/styleManager';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

/* eslint-disable react/prop-types */
export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    new StyleManager();
    // 百度统计脚本
    if (typeof window === 'undefined') return;

    const hostname = window.location.hostname;
    console.log('hostname', hostname);

    const hm = document.createElement('script');

    if (hostname === 'sailglobal.com.cn') {
      console.log('百度统计脚本--sailglobal 线上官网');
      hm.src = 'https://hm.baidu.com/hm.js?802ca1fd2e7d2e8adec4c8cd62c6faeb';
      hm.async = true;
      hm.defer = true; // 可选：让脚本在页面解析后执行
      const s = document.getElementsByTagName('script')[0];
      s.parentNode?.insertBefore(hm, s);
    }

    return () => {
      // 清理脚本元素，防止内存泄漏
      if (hm.parentNode) {
        hm.parentNode.removeChild(hm);
      }
    };
  }, []);

  return <Page>{children}</Page>;
}
